import React from 'react'

const component = 'search'

export function DefaultResult({
    title,
    link,
    metaDescription,
    tags = [],
    articleCategory = '',
    hideCategory = true,
    articleDate = '',
    hideDate = true,
    readMoreLabel = 'Read More',
}) {
    return (
        <div className={`${component}__result`}>
            <div className={`${component}__result-date`}>{articleDate && !hideDate ? articleDate : null}</div>
            <div className={`${component}__result-link`}>
                <a href={link} title={title}>
                    <h2>{title}</h2>
                </a>
            </div>
            {metaDescription ? <p className={`${component}__result-description`}>{metaDescription}</p> : null}
            {tags.length || (articleCategory && !hideCategory) ? (
                <div className={`${component}__result-meta`}>
                    {articleCategory && !hideCategory ? (
                        <span className={`${component}__result-tag`}>{articleCategory}</span>
                    ) : null}
                    {tags.length
                        ? tags.map((tag) => (
                              <span key={tag.title} className={`${component}__result-tag`}>
                                  {tag.title}
                              </span>
                          ))
                        : null}
                </div>
            ) : null}
            <div
                className={`${component}__result-read-more btn-wrapper js-cta-btn btn-inline btn--icon-fade-out-animation`}
            >
                <a className="btn button-text--primary btn cta-button" href={link} title={readMoreLabel}>
                    {readMoreLabel}
                </a>
                <div className="button--arrow"></div>
            </div>
        </div>
    )
}
